import { IJobRequestDTO, IPaginatedJobDTO } from 'src/api/dtos';
import CommonRepository from 'src/api/repositories/common/common.repository';
import api from 'src/api/rtk/rtk-api';

export default class CommonJobRepository extends CommonRepository {
  private static readonly baseRoute = '/jobs';
  private static readonly apiURL = this.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      getJobs: build.query<IPaginatedJobDTO, IJobRequestDTO>({
        query: (params) => {
          return { url: this.apiURL, method: 'get', params };
        },
      }),
    }),
  });
}
